// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const IntegrationProviderSchema = z.enum(['linear','jira','servicenow','github_issues','wiz','hackerone','xpanse','crowdstrike','crowdstrikeNgSiem','cortexXsiam','splunk','confluence','notion','google_drive','box','glean','slack','microsoftTeams','pagerduty','bugcrowd','upwind','jenkins','genericWaf','awsSecurityGroup','gcpFirewall','azureNsg','genericConfig','genericIps','aws','gcp','azure','torq'] as const);

export type IntegrationProviderType = `${z.infer<typeof IntegrationProviderSchema>}`

export default IntegrationProviderSchema;
